import React from 'react'
import { Box, Heading } from 'rebass/styled-components'
import AnimationWrapper from '../helpers/Animations'
import Spacer from '../components/general/Spacer'
import styled from 'styled-components'

const HorizontalRuler = styled(Box)`
    background-color: transparent;
    border-color: ${(props) => props.theme.colors.black};
    border-style: solid;
    border-width: 1px 0 0 0;
    display: block;
    height: 8px;
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 4px;
    margin-left: 0;
    padding: 0;
`

const HeadingModule = ({ options }) => {
    const underline = options.showUnderline ? <HorizontalRuler as='hr'/> : null
    return (
        <AnimationWrapper type="fade-up">
            <Box bg={options.bg || ''}>
                <Spacer spacing={options.spacing && options.spacing}>
                    <Heading as={(options.type === 'bigText') ? 'span' : options.type} variant={options.variant || options.type} textAlign={options.align || 'left' }>
                        {options.text}
                    </Heading>
                </Spacer>
                {underline}
            </Box>
        </AnimationWrapper>
    )
}

export default HeadingModule
